<div class="changepasswordwrapper">
  <div class="changecontent text-heading-3">Change Password</div>
  <hr />
  <div class="changedesc-content text-heading-5">Choose a unique password to protect your account.</div>
  <div class="updated-content text-para">Last updated: 25 December, 2023</div>
  <button class="password-button text-button update" (click)="openEditDialog()">Change Password</button>
</div>   